import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import SplitType from "split-type";
//import Lenis from "@studio-freight/lenis";

gsap.registerPlugin(ScrollTrigger);

// Toggle Image
function toggleImageClass() {
    const images = document.querySelectorAll(".imagetotoggle");
    images.forEach((image) => {
        const imageRect = image.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const imageMiddle = imageRect.top + imageRect.height / 2;
        const windowMiddle = windowHeight * 0.8; // 80% dello schermo

        if (imageMiddle <= windowMiddle) {
            image.classList.add("imageisactive");
        }
    });
}
window.addEventListener("scroll", toggleImageClass);
// End Toggle Image

// Parallax effect
const tlp = gsap.timeline();
tlp.to(".parallaxheader img", {
    yPercent: -20,
    ease: "power1.out",
    scrollTrigger: {
        trigger: ".parallaxheader",
        start: "top top+=124px",
        end: "bottom top",
        scrub: true,
        markers: false,
    },
});
// End Parallax effect
// text effects with css
$(document).ready(function () {
    var h = new IntersectionObserver(function (t, e) {
        t.forEach(function (t) {
            t.isIntersecting && t.target.classList.add("slide-up");
        });
    });
    document.querySelectorAll(".animate").forEach(function (t) {
        h.observe(t);
    });
});
// end text effects with css

// text effects with splitting
// 20240723: disabilitazione
/*
window.addEventListener("DOMContentLoaded", (event) => {
    let typeSplit = new SplitType("[text-split]", {
        types: "words, chars",
        tagName: "span",
    });

    function createScrollTriggerTextEffects(triggerElement, timeline) {
        ScrollTrigger.create({
            trigger: triggerElement,
            start: "top 60%",
            markers: false,
            onEnter: () => {
                timeline.play();
            },
        });
    }

    $("[words-slide-up]").each(function (index) {
        let tl = gsap.timeline({ paused: true });
        tl.from($(this).find(".word"), {
            opacity: 0,
            yPercent: 100,
            duration: 0.5,
            ease: "back.out(2)",
            stagger: { amount: 0.5 },
        });
        createScrollTriggerTextEffects($(this), tl);
    });

    $("[letters-slide-down]").each(function (index) {
        let tl = gsap.timeline({ paused: true });
        tl.from($(this).find(".char"), {
            yPercent: -120,
            duration: 0.3,
            ease: "power1.out",
            stagger: { amount: 0.7 },
        });

        createScrollTriggerTextEffects($(this), tl);
    });

    gsap.set("[text-split]", { opacity: 1 });
});
*/
// 20240723: fine disabilitazione
// end text effects with splitting

// text effect with reveal
// 20240723: disabilitazione
/*
const splitTypes = document.querySelectorAll("[text-reveal]");

splitTypes.forEach((char, i) => {
    const bg = char.dataset.bgColor;
    let fg = "#183c2a";
    let fgv = char.dataset.fgColor;
    if (fgv == "verdescuro") {
        fg = "#183c2a";
    } else if (fgv == "verdemedio") {
        fg = "#016338";
    } else if (fgv == "bluscuro") {
        fg = "#014a6c";
    } else if (fgv == "verdefluo") {
        fg = "#00b566";
    } else if (fgv == "rossobordo") {
        fg = "#880d27";
    } else if (fgv == "grigioscuro") {
        fg = "#353535";
    }

    const text = new SplitType(char, { types: "chars,words" });

    gsap.fromTo(
        text.chars,
        {
            color: bg,
        },
        {
            color: fg,
            duration: 0.3,
            stagger: 0.02,
            scrollTrigger: {
                trigger: char,
                start: "top 60%",
                //end: "top 20%",
                scrub: false,
                markers: false,
                toggleActions: "play none none none",
            },
        }
    );
});
*/
// 20240723: fine disabilitazione
// end text effect with reveal

// remove lazy load images

addEventListener("load", () => {
    $("img[loading='lazy']").each(function () {
        $(this).addClass("lazyimg");
    });

    $(window).scroll(function () {
        $(".lazyimg").each(function () {
            if (isScrolledIntoView($(this))) {
                $(this).removeClass("lazyimg");
                $(this).prop("loading", "eager");
                //ScrollTrigger.refresh();
                window.dispatchEvent(new Event("resize"));
            }
        });
    });

    function isScrolledIntoView(elem) {
        var $elem = $(elem);
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return elemBottom <= docViewBottom + 100 || elemTop >= docViewTop - 100; //false oder true
    }
});

// end remove lazy loas images
